<div class="dialog-header">
  <h1 mat-dialog-title>Changement de rôle</h1>
  <button mat-icon-button [mat-dialog-close]="false" matTooltip="Fermer">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="blueMode">
  <p>Une session de 1h sera lancée avec ce rôle</p>
  <mat-form-field>
    <mat-label>Choisir un rôle</mat-label>
    <mat-select [(value)]="selectedRole">
      <mat-option *ngFor="let role of roles" [value]="role">{{ role }}</mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="blueMode" align="end">
  <button mat-raised-button color="primary" matTooltip="Enregistrer" (click)="valider()">Enregistrer</button>
  <button mat-raised-button color="accent" matTooltip="Annuler" (click)="cancelSwitchRole()">Annuler</button>
</mat-dialog-actions>
